import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MonitorSmartphone, LogOut } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const SessionsCard = ({ wide = false }) => {
  const [others, setOthers] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/auth/sessions").then((r) => setOthers(r.data.others)).catch(() => {});
  }, []);
  const signOutOthers = async () => {
    setBusy(true);
    try {
      const r = await api.post("/auth/sessions/sign-out-others");
      setOthers(0);
      toast.success(r.data.ended ? `Signed out of ${r.data.ended} other device${r.data.ended === 1 ? "" : "s"}` : "No other devices were signed in");
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className={`rounded-lg border border-[#E5E7EB] bg-white p-5 flex flex-col gap-4 ${wide ? "sm:flex-row sm:items-center" : ""}`} data-testid="sessions-card">
      <div className="w-11 h-11 shrink-0 rounded-md bg-[#FFF0F0] text-[#E60000] grid place-items-center"><MonitorSmartphone className="w-5 h-5" /></div>
      <div className="flex-1 min-w-0">
        <div className="font-heading font-bold text-[#111]">Signed-in devices</div>
        <p className="text-sm text-gray-500" data-testid="sessions-other-count">
          {others === null ? "Checking…" : others === 0 ? "You are only signed in on this device." : `You are also signed in on ${others} other device${others === 1 ? "" : "s"}.`}
        </p>
      </div>
      <button type="button" onClick={signOutOthers} disabled={busy} className={`inline-flex items-center justify-center gap-2 h-10 px-4 rounded-md bg-[#111] text-white text-sm font-semibold hover:bg-[#E60000] disabled:opacity-60 transition-colors w-full ${wide ? "sm:w-auto" : ""}`} data-testid="sign-out-everywhere-button">
        <LogOut className="w-4 h-4" />{busy ? "Signing out…" : "Sign out everywhere else"}
      </button>
    </div>
  );
};
